import getUuid from 'widget/helpers/uuid';
import CallLogAPI from 'dashboard/api/calllog';

const {
    JANUS_API_BASE_URL: janusApiBaseUrl,
} = window.globalConfig || { JANUS_API_BASE_URL: "https://janus.intelia.com.br" };

export default {
    data() {
        return {
            janusUrl: `${janusApiBaseUrl}/janus`,
            sessionId: null,
            handleId: null,
            pcPub: null,
            joining: false,
            joined: false,
            muted: false,
        };
    },
    beforeDestroy() {
        this.sessionId = null;
        this.handleId = null;
        this.pcPub = null;
        this.joining = false;
        this.joined = false;
        this.muted = false;
    },
    methods: {
        async initializePeerConnection() {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            this.pcPub = new RTCPeerConnection({
                iceServers: [{ urls: "stun:stun.l.google.com:19302" }],
            });

            stream.getTracks().forEach(track => this.pcPub.addTrack(track, stream));
            this.pcPub.ontrack = (event) => {
                document.getElementById("roomaudio").srcObject = event.streams[0];
            };

            this.pcPub.onicecandidate = async (event) => {
                if (event.candidate == null) {
                    await this.janusRequest(`${this.janusUrl}/${this.sessionId}/${this.handleId}`, {
                        janus: "trickle",
                        candidate: { completed: true },
                        transaction: getUuid()
                    });
                } else if (event.candidate.candidate.includes("srflx") || event.candidate.candidate.includes("relay")) {
                    await this.janusRequest(`${this.janusUrl}/${this.sessionId}/${this.handleId}`, {
                        janus: "trickle",
                        candidate: event.candidate,
                        transaction: getUuid()
                    });
                }
            };

            this.pcPub.oniceconnectionstatechange = () => {
                console.log("🧊 ICE State:", this.pcPub.iceConnectionState);
                if (this.pcPub.iceConnectionState === "connected") {
                    // TODO: Handle connected state
                }
                if (this.pcPub.iceConnectionState === "disconnected" || this.pcPub.iceConnectionState === "failed") {
                    this.hangup();
                }
            };
        },
        async janusRequest(url, data) {
            const res = await fetch(url, {
                method: "POST",
                body: JSON.stringify(data)
            });
            return res.json();
        },
        async joinRoom() {  
            const self = this;
            await this.createConnectionWebrtc(async function (offer) {
                const { data: responsePub } = await CallLogAPI.create({
                    call_action: 'accept',
                    conversation_id: self.conversation.primary_key,
                    sdp: offer.sdp
                });
                return responsePub;
            });
        },
        async joinRoomOutgoing() {
            const self = this;
            await this.createConnectionWebrtc(async function (offer) {
                const { data: responsePub } = await CallLogAPI.outgoing({
                    call_action: 'outgoing',
                    conversation_id: self.conversation.primary_key,
                    sdp: offer.sdp
                });
                return responsePub;
            });
        },
        async createConnectionWebrtc(cbRequest) {
            this.joining = true;
            this.joined = false;
            console.log("🔊 Conectando ao Publisher...");
            const offer = await this.pcPub.createOffer({ offerToReceiveAudio: true });
            const responsePub = await cbRequest(offer);
            console.log("Response from server:", responsePub);
            this.sessionId = responsePub.session_id;
            this.handleId = responsePub.handle_id;

            await this.pcPub.setLocalDescription(offer);

            const jsepPub = await this.waitForJsep();
            if (!jsepPub) {
                throw new Error("Janus: no jsep returned, cannot establish WebRTC connection");
            }
            await this.pcPub.setRemoteDescription(new RTCSessionDescription(jsepPub));
            this.joining = false;
            this.joined = true;
            console.log("🎤 Publisher conectado");
        },
        async toogleAudioMute() {
            console.log("Toggle mute. Current state:", this.muted);
            await this.janusRequest(`${this.janusUrl}/${this.sessionId}/${this.handleId}`, {
                janus: "message",
                body: {
                    request: "configure",
                    muted: !this.muted,
                },
                transaction: getUuid()
            });
            this.muted = !this.muted;
            console.log("New mute state:", this.muted);
        },
        async waitForJsep() {
            try {
            for (let i = 0; i < 30; i++) {
                const response = await fetch(`${this.janusUrl}/${this.sessionId}?rid=${Date.now()}`);
                if (!response.ok) {
                    throw new Error(`Janus poll failed with HTTP ${response.status}`);
                }
                const poll = await response.json();
                console.log("Polling", poll);
                if (poll.janus === "event" && poll.sender === this.handleId && poll.jsep) {
                    return poll.jsep;
                }
                await new Promise(r => setTimeout(r, 500));
            }
            throw new Error("Janus poll timed out: no jsep received after 30 attempts");
            } catch (e) {
                console.error("Error waiting for jsep:", e);
                this.hangup();
                throw e;
            }
        },
        async hangup() {
            if (this.pcPub) {
                this.pcPub.close();
                this.pcPub = null;
            }
            if (this.handleId) {
                await CallLogAPI.create({
                    call_action: 'hangup',
                    conversation_id: this.conversation.primary_key,
                });
                this.handleId = null;
                this.sessionId = null;
            }
            this.joining = false;
            this.joined = false;
            if (this.stopCallAudio) {
                this.stopCallAudio('HANGUP');
            }
            console.log("🔚 Desconectado.");
        },
        async rejectCall() {
            await CallLogAPI.create({
                call_action: 'reject',
                conversation_id: this.conversation.primary_key,
            });
        },
        keepalive() {
            setInterval(async () => {
                if (this.sessionId) {
                    await this.janusRequest(`${this.janusUrl}/${this.sessionId}`, {
                        janus: "keepalive",
                        transaction: getUuid()
                    });
                }
            }, 30000); // every 30 seconds
        }
    }
}